/**
 * recaptchaMixin — obține token reCAPTCHA v3 înainte de trimiterea formularelor.
 * Dacă reCAPTCHA nu este configurat (development), returnează un string gol.
 */
export default {
    methods: {
        async getRecaptchaToken(action) {
            if (!window.recaptchaSiteKey) {
                return '_no_captcha_key';
            }
            
            if (typeof window.grecaptcha === 'undefined') {
                return '_no_captcha';
            } 
            
            return new Promise((resolve) => {
                window.grecaptcha.ready(() => {
                    window.grecaptcha
                        .execute(window.recaptchaSiteKey, { action })
                        .then(resolve)
                        .catch((error) => {
                            console.error('[reCAPTCHA] Token execution failed:', error);
                            resolve('');
                        });
                });
            });
        },
    },
};
